import { createContext, useContext, useState } from "react";

const MenuContext = createContext();

export const MenuProvider = ({children}) => {
        
        const [drawer,setDrawer]=useState(false);
        const [language,setLanguage]=useState("it");

        return ( 
                <MenuContext.Provider
                value={{
                        drawer,
                        setDrawer,
                        language,
                        setLanguage
                }}
                >
                {children}
                </MenuContext.Provider>
         );
};
 
export const useMenu=()=>{
        return useContext(MenuContext);
}